"use strict";

function LoansRouter() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];
  this.loanStateRoutingEnabled = true;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super(); // _LoanController

    if (this.isPendingLoanOfferDecision()) {
      this._history.replaceUrl(this.paths.loans.preapproval);
    }
  };

  this.initPage = function () {};

  this.destroy = function () {};
}